"use client";

import React from "react";
import { Globe, Smartphone, Cloud } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const servicesData = [{
  title: "Fret Maritime / Sea Freight",
  description: "Solutions de transport maritime fiables pour vos marchandises à travers le monde via le Port Autonome de Dakar. / Reliable sea freight solutions for your cargo worldwide via the Port of Dakar.",
  icon: Globe,
  codeSnippet: `VESSEL: F2S DAKAR EXPRESS\nVOYAGE: 2409W\nPOL: DKR (DAKAR)\nPOD: RTM (ROTTERDAM)\nSTATUS: LOADING\nCONTAINER: 40HC-F2S-882`
}, {
  title: "Transport Terrestre / Road Freight",
  description: "Livraison sécurisée et suivi en temps réel à travers le Sénégal et toute la sous-région Ouest-Africaine. / Secure delivery and real-time tracking across Senegal and the West African sub-region.",
  icon: Smartphone,
  codeSnippet: `FLEET: TRUCK-F2S-04\nDRIVER: AMADOU FALL\nROUTE: DKR-BKO\nLOAD: 28 TONS\nTRACKING: ACTIVE\nGPS: 14.7167, -17.4677`
}, {
  title: "Fret Aérien / Air Freight",
  description: "Expéditions aériennes rapides et sécurisées pour vos marchandises sensibles au facteur temps. / Fast and secure air shipments for your time-sensitive and high-value cargo.",
  icon: Cloud,
  codeSnippet: `FLIGHT: F2S-CARGO-99\nAWB: 577-908821\nORIGIN: DSS (DAKAR)\nDEST: CDG (PARIS)\nTEMP: CONTROLLED\nPRIORITY: HIGH`
}];
export default function OurTechnologicalEcosystem() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223966" id="nos-solutions-de-transport-our-transport-solutions" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#0A1F4408_1px,transparent_1px),linear-gradient(to_bottom,#0A1F4408_1px,transparent_1px)] bg-[size:32px_32px] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_50%,#000_70%,transparent_100%)]"></div>

      <style>
        {`
          @keyframes scrollCode {
            0% { transform: translateY(0); }
            100% { transform: translateY(-50%); }
          }
          .animate-scroll-code {
            animation: scrollCode 15s linear infinite;
          }
        `}
      </style>

      <div ref={ref} className={`container relative z-10 mx-auto px-4 transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        <div className="mb-16 text-center">
          <h2 className="font-default mb-4 text-3xl font-bold tracking-tight text-primary md:text-5xl">
            Nos Solutions de Transport / Our Transport Solutions
          </h2>
          <p className="font-sans text-muted-foreground mx-auto max-w-2xl text-lg">
            Une expertise logistique globale avec un ancrage africain fort pour connecter vos marchés au reste du monde.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {servicesData.map((service, i) => <div data-index={i} key={i} className="h-full">
              <Card className="group relative h-full overflow-hidden border-border bg-card/60 py-0 backdrop-blur-md transition-all duration-500 hover:border-primary-foreground hover:shadow-lg">
                {}
                <div className="absolute inset-0 z-0 flex items-start justify-center overflow-hidden opacity-10 transition-opacity duration-500 group-hover:opacity-20">
                  <pre className="animate-scroll-code font-mono text-xs text-primary-foreground">
                    {service.codeSnippet}
                    {"\n"}
                    {service.codeSnippet}
                  </pre>
                </div>

                {}
                <div className="absolute inset-0 z-0 bg-primary-foreground/0 transition-colors duration-500 group-hover:bg-primary-foreground/5"></div>

                <CardHeader className="relative z-10 px-8 pt-8 pb-4">
                  <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-xl bg-primary/5 text-primary transition-all duration-500 group-hover:bg-primary-foreground/20 group-hover:text-primary-foreground group-hover:shadow-md">
                    <service.icon className="h-7 w-7" />
                  </div>
                  <CardTitle className="font-default text-2xl font-bold tracking-tight text-primary">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="relative z-10 px-8 pb-8 pt-0">
                  <CardDescription className="font-sans text-base leading-relaxed text-muted-foreground">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}